<div class="wrapper">
  <div class="abs-center">
      <div class="text-center my-3">
          <h2 class="mb-3 error-403 text-danger">403</h2>
          <h3 class="mb-4 lead text-danger">Acesso negado, você não tem permissão para acessar esta página.</h3>
          <button type="button" class="btn btn-outline-danger mb-2" [routerLink]="['/home']">Retornar para o sistema</button>
      </div>
  </div>
</div>
